import * as Plaid from './ducks/actions'

export default Plaid;
